module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-22.d15c764a.png";